import PropTypes from 'prop-types';

import { StatusBadge } from '#/modules/commonComponents/badge';
import { formatPurchaseOrderStatusLabel } from '#/modules/srmMgmt/purchaseOrder/helper/purchaseOrderStatus';

const PurchaseOrderStatusBadge = ({ status, size = 'default', className }) => (
  <StatusBadge
    status={status}
    label={formatPurchaseOrderStatusLabel(status)}
    size={size}
    className={className}
  />
);

PurchaseOrderStatusBadge.propTypes = {
  status: PropTypes.string,
  size: PropTypes.oneOf(['default', 'sm']),
  className: PropTypes.string,
};

export default PurchaseOrderStatusBadge;
